module.exports = __webpack_public_path__ + "static/media/issuer_financial_data.349e9083.svg";